import { Component } from 'react';
export default class AddUser extends Component {
    render() {
        return (
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11.25 9.6875C12.9075 9.6875 14.25 8.345 14.25 6.6875C14.25 5.03 12.9075 3.6875 11.25 3.6875C9.5925 3.6875 8.25 5.03 8.25 6.6875C8.25 8.345 9.5925 9.6875 11.25 9.6875ZM4.5 8.1875V5.9375H3V8.1875H0.75V9.6875H3V11.9375H4.5V9.6875H6.75V8.1875H4.5ZM11.25 11.1875C9.2475 11.1875 5.25 12.1925 5.25 14.1875V15.6875H17.25V14.1875C17.25 12.1925 13.2525 11.1875 11.25 11.1875Z" fill="#2E7BB9"/>
            </svg>
        )
    }
};